import * as Luxon from 'luxon'
import Recoil from 'recoil';
import remember_me from './remember_me';
import last_doctor_id from './last_doctor_id';
import last_hospital_id from './last_hospital_id';
import T from 'utils/T';

export const floatings = {
  list: Recoil.atomFamily({ key: 'floatings.list', default: () => [], dangerouslyAllowMutability: true }),
  hash: Recoil.atomFamily({ key: 'floatings.hash', default: () => ({}), dangerouslyAllowMutability: true }),
};

export const communication = {
  access_token: Recoil.atom({ key: 'communication.access_token', default: null }),
  queues: Recoil.atomFamily({ key: 'communication.queues', default: () => [], dangerouslyAllowMutability: true }),
}

const parameters = window.location.search?.substring(1)?.split('&')?.map(parameter => parameter.split('='));
const options = {};
parameters.forEach(parameter => {
  switch (parameter[0]) {
    case 'current':
      options.current = parameter[1];
      return;
    default:
      return;
  }
});

const otu = window.location.search.substring(1).split('&').map(query => query.split('=')).filter(([key, value]) => key === 'otu').map(([key, value]) => value)[0];

export const navigation = {
  pages: Recoil.atomFamily({
    key: 'navigation.pages',
    default: (category) => {
      switch (category) {
        case 'App': {
          return [
            ...(otu ? ['Reset'] : ['Login']),
            ...(options.current ? [options.current] : [])
          ];
        }
        case 'Overview': {
          return [
            'OverviewScatter',
            'OverviewAGP', // default
          ];
        }
        case 'Report': {
          return [
            'ReportInsulin',
            'ReportExercise',
            'ReportDiet',
            'ReportBloodGlocose', // default
          ];
        }
        case 'Exercise': {
          return [
            'ReportExerciseCalories',
            'ReportExerciseSteps', // default
          ];
        }
        case 'Simulation': {
          return [
            'SimulationInsulin',
            'SimulationDiet',
            'SimulationExercise', // default
          ];
        }
        case 'SimulationDiet': {
          return [
            'SimulationDietGraph',
            'SimulationDietTable', // default
          ];
        }
        default: {
          return [];
        }
      }
    },
    dangerouslyAllowMutability: true,
  }),
};

const items = [
  { key: 'A', label: T('전체') },
  { key: 'B', label: T('혈당') },
  { key: 'E', label: T('활동') },
  { key: 'D', label: T('식사') },
  { key: 'I', label: T('인슐린') }
];

export const assets = {
  period_start: Recoil.atom({ key: 'assets.period_start', default: Luxon.DateTime.now().minus({ days: 90 }).startOf('day').toFormat('yyyyMMdd') }),
  period_end: Recoil.atom({ key: 'assets.period_end', default: Luxon.DateTime.now().minus({ days: 1 }).startOf('day').toFormat('yyyyMMdd') }),
  doctor_info: Recoil.atom({ key: 'assets.doctor_info', default: {} }),
  patient_list: Recoil.atom({ key: 'assets.patient_list', default: [] }),
  patient_hash: Recoil.atom({ key: 'assets.patient_hash', default: {} }),
  patient_no: Recoil.atom({ key: 'assets.patient_no', default: null }),
  agp_base: Recoil.atom({ key: 'assets.agp_base', default: [] }),
  agp: Recoil.atom({ key: 'assets.agp', default: ({ uninitialized: true }) }),
  guide_list: Recoil.atom({ key: 'assets.guide_list', default: [] }),
  guide_reload: Recoil.atom({ key: 'assets.guide_reload', default: 0 }),
  glocose_exists: Recoil.atom({ key: 'assets.glocose_exists', default: {} }),
  glocose_exists2: Recoil.atom({ key: 'assets.glocose_exists2', default: {} }),
  data: Recoil.atomFamily({ key: 'assets.data', default: () => ({ uninitialized: true }) }),
  pdf_targets: Recoil.atom({ key: 'assets.pdf_targets', default: items.reduce((a, c) => ({ ...a, [c.key]: true }), {}) }),
  sim_meal: Recoil.atom({ key: 'assets.sim_meal', default: {} }),
  show1: Recoil.atom({ key: 'assets.show1', default: false }),
  std_food_name: Recoil.atom({ key: 'assets.std_food_name', default: '' }),
  cp_food_names: Recoil.atom({ key: 'assets.cp_food_names', default: ['', '', ''] }),
  selected_period: Recoil.atom({ key: 'assets.selected_period', default: null }),
};

export const app = {
  logined: Recoil.atom({ key: 'app.logined', default: !!options.current }),
  inert: Recoil.atom({ key: 'app.inert', default: false }),
  remember_me,
  last_doctor_id,
  last_hospital_id,
};

